import { AnimatedSection } from './AnimateSection';
import { Link, NavLink } from 'react-router-dom';
import { useState } from 'react';

export const PrintableElement = ({disableAnimation}) => {
  const [copied, setCopied] = useState(false);

  const handlePrint = () => {
    window.print();
  };

  const handleCopyEmail = () => {
    navigator.clipboard.writeText('info@daverosetholley.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      {/* Download & Print Buttons */}
      <div className="fixed top-5 right-5 md:top-10 md:right-10 z-50 flex flex-col md:flex-row gap-2 md:gap-3 no-print">
        <button
          onClick={handlePrint}
          className="px-3 py-2 md:px-4 md:py-2 bg-charcoal text-custom-background hover:bg-[#ff6347] transition-colors duration-300 font-[500] text-xs md:text-sm tracking-wide uppercase whitespace-nowrap"
        >
          Print
        </button>
        <a
          href="/Daverose-CV.pdf"
          download="Daverose-Tholley-CV.pdf"
          className="px-3 py-2 md:px-4 md:py-2 bg-charcoal text-custom-background hover:bg-[#ff6347] transition-colors duration-300 font-[500] text-xs md:text-sm tracking-wide uppercase whitespace-nowrap"
        >
          Download
        </a>
      </div>

      <div id="printableTable" className='grid lg:grid-rows-[min_content_min_content] gap-8 md:px-[80px] text-charcoal bg-custom-background pt-16 md:pt-0'>
        <div className='grid gap-5 md:gap-10 lg:grid-cols-[1fr_1fr] items-center'>
            <div className='grid gap-2'>
                <h1 className={`intro-line text-[12vw] sm:text-[10vw] md:text-[4vw] leading-[1em] font-grandslang`}>Daverose Tholley</h1>
                <p className='intro-line uppercase text-[14px] sm:text-[16px] md:text-[18px] font-[550] text-charcoal tracking-[2px]' role="heading" aria-level="2">Frontend Engineer</p>
                <p className='intro-line text-[14px] md:text-[16px] font-[450] leading-[1.9em] tracking-[.5px] flex flex-col md:flex-row md:items-center gap-1 md:gap-0'>
                  <span className='intro-line'><NavLink to='https://daverosetholley.com' className='underline-slide white'>daverosetholley.com</NavLink></span>
                  <span className='hidden md:inline mx-2'>|</span>
                  <span className='intro-line inline-flex items-center gap-2'>
                    <NavLink className='underline-slide white' to="mailto:info@daverosetholley.com?subject=Interested%20in%20your%20frontend%20engineering%20services&body=Hi%20Daverose,%0D%0A%0D%0AI%20hope%20you're%20doing%20well!%0D%0A%0D%0AI'm%20reaching%20out%20because%20I'm%20curious%20about%20your%20frontend%20engineering%20services%20and%20how%20they%20could%20fit%20with%20my%20project.%20Would%20you%20be%20available%20for%20a%20quick%20chat%20to%20discuss%20further%3F%0D%0A%0D%0AThanks%20in%20advance!">info@daverosetholley.com</NavLink>
                    <button
                      onClick={handleCopyEmail}
                      className="no-print text-[10px] md:text-xs text-charcoal/50 hover:text-[#ff6347] transition-colors duration-200 px-1"
                      title="Copy email to clipboard"
                    >
                      {copied ? '✓' : 'Copy'}
                    </button>
                  </span>
                </p>
            </div>
            <div className='w-fit'>
                <p className='intro-line font-grandslang text-[14px] sm:text-[16px] md:text-[1.4vw] leading-[1.7em] md:leading-[1.9em] font-[600]'>
                    I am a frontend engineer dedicated to crafting thoughtful user experiences and delivering impactful solutions, including a proven track record of delivering scalable and high-performance solutions at Enyata. Proficient in modern web technologies, creating seamless, intuitive interfaces and Agile development practices, with a passion for optimizing processes and driving team success.
                </p>
            </div>
        </div>
        <div className='grid gap-10 md:gap-10 lg:grid-cols-[1fr_1fr]'>
                <div className='grid gap-[60px] md:gap-[80px]'>
                    <section aria-label="Professional Experience">
                    <div className='grid md:grid-cols-[min-content_1fr] md:gap-10'>
                        <div className='grid h-fit md:justify-items-center'>
                            <div className={`m-5 bg-charcoal md:w-[2px] h-[1px] w-[50px] md:h-[50px]`}></div>
                            <h2 className='flip-text uppercase text-[18px] font-[550] text-charcoal tracking-[2px]'>EXPERIENCE</h2>
                        </div>
                <div className='text-[14px] leading-loose font-[450] grid gap-10'>

                  <AnimatedSection disableAnimation={disableAnimation}>
                                <Link to='https://www.davetsolutions.com/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px]'>DAVE T Engineering, Technology and Trading Solutions</Link>
                                <br/>
                                Co-founder (January 2021 – Present)
                                <br />
                                <br/>
                                I co-lead the strategic relaunch of Dave T, transitioning a 1988 construction legacy into a modern firm focused on climate-resilient infrastructure. I drive the integration of human-centered design and digital tools to address urban resilience. Currently, we are piloting a flood-monitoring prototype to enhance community adaptation in climate-vulnerable zones, combining engineering excellence with gender-responsive data solutions to ensure no one is left behind.                                <br />
                                <br/>
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>
                            </AnimatedSection>
                            <AnimatedSection disableAnimation={disableAnimation}>
                                <Link to='https://www.femnet.org/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px]'>FEMNET (African Women's Development and Communication Network)</Link>
                                <br/>
                                Vice Chair, Girls & Young Women Board (June 2025 – Present)
                                <br />
                                <br/>
                                As Vice Chair of the Girls & Young Women Board at FEMNET, I contribute to strategic decision-making and governance focused on advancing women's rights and gender equality across Africa. I collaborate with board members to guide organizational initiatives, ensure accountability, and support programs that empower young women and girls through advocacy, capacity building, and policy influence.
                                <br />
                                <br/>
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>
                            </AnimatedSection>
                            <AnimatedSection disableAnimation={disableAnimation}>
                                <Link to='https://www.enyata.com/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px]'>ENYATA GHANA</Link>
                                <br/>
                                Frontend Engineer (February 2022 – June 2025)
                                <br/>
                                Software Engineer Trainee (October 2021 – February 2022)
                                <br />
                                <br/>
                               As a Frontend Engineer at Enyata Ghana, I specialize in developing and enhancing user interfaces for web applications, focusing on creating intuitive and visually appealing designs that align with user needs. I collaborate closely with cross-functional teams, including designers, backend developers, and product managers, to ensure seamless integration and delivery of impactful solutions. My role involves:
                              <br />
                               <br />
                              
                                - Designing and implementing responsive and user-friendly interfaces using modern frontend technologies such as HTML, CSS, JavaScript, and React.
                                 <br />
                                - Optimizing web applications for speed, scalability, and performance.
                                <br />
                              - Ensuring cross-browser compatibility and conducting regular quality assurance tests to improve user experience.
                                <br />
                                - Collaborating with backend developers to integrate APIs and ensure smooth data flow between frontend and backend systems.
                              <br />
                                - Engaging in regular code reviews, offering and receiving constructive feedback to improve the codebase and maintain best practices.
                              <br />
                              - Contributing to the overall product strategy, offering insights based on user feedback and testing results to drive continuous improvements.
                              <br />
                                <br />
                              
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>
                            <AnimatedSection disableAnimation={disableAnimation}>
                                <Link to='https://wacsi.org/' className='uppercase font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px]'>West Africa Civil Society Institute (WACSI)</Link>
                                <br/>
                                Data Migration Volunteer (June 2021 - July 2021)
                                <br />
                                <br />
                                In my role, I reviewed data uploaded by the organization to identify, analyze, and interpret trends or patterns within the datasets. I created backups of all registered organizations' accounts across 18 African countries in both English and French, transitioning them from the old website to the upgraded version. Additionally, I backed up all videos and images on the old platform in both languages. I compiled a comprehensive report documenting every discrepancy and inconsistency as errors to be addressed later. Beyond my academic and research experiences, my work at WACSI allowed me to gain professional practice in organizing and coordinating civil society and non-governmental organizations' funded projects by fulfilling diverse administrative tasks.
                                <br />
                                <br/>
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>   
                            <AnimatedSection disableAnimation={disableAnimation}>
                                <Link to='https://www.statistics.sl/' className='uppercase font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px]'>Statistics Sierra Leone</Link>
                                <br/>
                                Data Cleaner - Volunteer | 2019 SIERRA LEONE DEMOGRAPHIC AND HEALTH SURVEY (SLDHS) (June 2019 - September 2019)
                                <br />
                                <br />
                                In my role, Using CSPro 6.3 with proper supervision, I had to use problem-solving skills to remove and/or amend resolving all discrepancies and inconsistencies thereby producing clean data for better decision making. By being thorough and effective, I helped lessen the burden and workload on my partner/ supervisor, therefore, increasing the work pace and greatly decreasing the number of discrepancies to be resolved
                                <br />
                                <br/>
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>  
                            <AnimatedSection disableAnimation={disableAnimation}>
                                <Link to='http://www.recentdst.com/' className='uppercase font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px]'>Research Center for Development in Science and Technology SL Ltd</Link>
                                <br/>
                                Front-End Website Developer & Data Entry Operator - Intern (July 2018 - September 2018)
                                <br />
                                <br />
                                - Created the first-ever website for the company, significantly enhancing their online presence and accessibility, resulting in a broader audience reach and an increase in client acquisition.
                                 <br />
                                <br />
                                - Collected and cleaned customer feedback survey data, ensuring accurate and error-free information for research analysts to perform precise SWOT analyses, thereby helping clients capitalize on their strengths.
                                <br />
                                <br/>
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>      
                      </div>

                    </div>
                    </section>

            <section aria-label="Education">
              <div className='grid md:grid-cols-[min-content_1fr] md:gap-10'>
                <div className='grid h-fit md:justify-items-center'>
                  <div className={`m-5 bg-charcoal md:w-[2px] h-[1px] w-[50px] md:h-[50px]`}></div>
                  <h2 className='flip-text uppercase text-[18px] font-[550] text-charcoal tracking-[2px]'>EDUCATION</h2>
                </div>
                <div className='text-[14px] leading-loose font-[450] grid gap-10'>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <span className='font-[600] transition text-charcoal hover:text-[#ff6347] text-[16px]'>LANCASTER UNIVERSITY GHANA</span>
                    <br />
                    Bachelor's degree (Hons), Computer Science
                    <br />
                    (Graduated 2021)
                    <br />
                    Grade: <b>First Class</b>
                    <br />
                    Award: <b>The Lancaster Award Gold</b>
                    <br />
                    <br />

                    Activities and societies: Computer Science Society, Psychology Society
                    <br />
                    <br />
                  </AnimatedSection>
                </div>
              </div>
            </section>
            <section aria-label="Workshops and Events">
              <div className='grid md:grid-cols-[min-content_1fr] md:gap-10'>
                <div className='grid h-fit md:justify-items-center'>
                  <div className={`m-5 bg-charcoal md:w-[2px] h-[1px] w-[50px] md:h-[50px]`}></div>
                  <h2 className='flip-text uppercase text-[18px] font-[550] text-charcoal tracking-[2px]'>WORKSHOPS</h2>
                </div>
                <div className='text-[14px] h-fit leading-loose font-[450] grid gap-10'>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <span className='uppercase font-[600] text-charcoal text-[16px]'>UNICEF</span>
                    <br />
                    <strong>Participant</strong>   | Jul 2019 - Aug 2019
                    <br />
                    Participated in the Capacity Development Initiative aimed at enhancing the effectiveness and relevance of the SDG Voluntary National Review (VNR) in Sierra Leone. The event was held from July 29 to August 1, 2019, at the Wusum Hotel in Makeni, Sierra Leone.
                    <br />
                    <br />
                    <div className={`bg-charcoal w-[50px] h-[2px]`}></div>
                  </AnimatedSection>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <span className='uppercase font-[600] text-charcoal text-[16px]'>Statistics Sierra Leone</span>
                    <br />
                    <strong>Associated with UNICEF </strong>
                    <br />
                    <strong>Participant</strong>   | Aug 2019
                    Attended the Country Training on Stats SL Info Applications, held from August 13 to 17, 2019, at UNICEF HQ in Freetown, Sierra Leone.
                    <br />
                    <br />
                    <div className={`bg-charcoal w-[50px] h-[2px]`}></div>
                  </AnimatedSection>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <span className='uppercase font-[600] text-charcoal text-[16px]'>TEDxYouth@KingTom</span>
                    <br />
                    <strong>Volunteer</strong>   | Jul 2018
                    <br />
                    - Ushered guests to their respective seats and served refreshments during breaks.
                    <br />
                    - Assisted colleagues with clean-up tasks after the event.
                    <br />
                    - Collaborated with the event coordination team to ensure smooth event flow and positive attendee experiences.
                    <br />
                    <br />
                    <div className={`bg-charcoal w-[50px] h-[2px]`}></div>
                  </AnimatedSection>
                </div>
              </div>
            </section>
            <section aria-label="Soft Skills">
              <div className='grid md:grid-cols-[min-content_1fr] md:gap-10'>
                <div className='grid h-fit md:justify-items-center'>
                  <div className={`m-5 bg-charcoal md:w-[2px] h-[1px] w-[50px] md:h-[50px]`}></div>
                  <h2 className='flip-text uppercase text-[18px] font-[550] text-charcoal tracking-[2px]'>SOFT SKILLS</h2>
                </div>
                <div className='text-[14px] h-fit leading-loose font-[450] grid gap-10'>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    The experience I've gained through various roles in my career has equipped me with a diverse range of soft skills. I have collaborated closely with designers and engineers, and I have a deep understanding of both technical and design aspects of product delivery. These skills have strengthened my ability to:
                    <br />
                    <br />
                    - <strong>Problem-Solving:</strong> Adept at analyzing complex issues and developing effective solutions.
                    <br />
                    - <strong>Stakeholder Communication:</strong> Skilled at building strong partnerships and clearly conveying ideas to cross-functional teams, ensuring alignment with organizational goals and stakeholder expectations.
                    <br />
                    - <strong>Persuasive Communication:</strong> Adept at conveying ideas and influencing decision-making.
                    <br />
                    - <strong>Creativity:</strong> Innovative in designing user-friendly interfaces and finding unique solutions.
                    <br />
                    - <strong>Attention to Detail:</strong> Thorough in ensuring the quality and functionality of the final product.
                    <br />
                    - <strong>Adaptability:</strong> Quick to learn and implement new technologies and methodologies.
                    <br />
                    - <strong>Teamwork:</strong> Skilled at working in diverse teams to achieve common goals.
                    <br />

                    - <strong>Strategic Governance & Leadership:</strong> Experienced in guiding organizational direction and ensuring accountability within high-level boards to advance gender equality.
                    <br />

                    - <strong>Human-Centered & Inclusive Design:</strong> Skilled at centering diverse user needs and gender-responsive data to build equitable climate solutions.
                    <br />

                    - <strong>Cross-Sector Collaboration:</strong> Adept at bridging the gap between engineering, grassroots advocacy, and policy to drive sustainable community impact.


                    <br />
                    <br />
                    <div className={`bg-charcoal w-[50px] h-[2px]`}></div>
                  </AnimatedSection>

                  <AnimatedSection disableAnimation={disableAnimation}>
                    <span className='uppercase font-[600] text-charcoal text-[16px]'>Personal Interests</span>
                    <br />
                    My creative endeavors, like interior design, sharpen my problem-solving skills, while community initiatives reflect my commitment to using technology for good.
                    <br />
                    <br />
                    <div className={`bg-charcoal w-[50px] h-[2px]`}></div>
                  </AnimatedSection>
                </div>
              </div>
            </section>
          </div>
          <div className='grid gap-[60px] md:gap-[80px] h-fit'>

            <section aria-label="Portfolio Projects">
              <div className='grid md:grid-cols-[min-content_1fr] md:gap-10'>
                <div className='grid h-fit md:justify-items-center'>
                  <div className={`m-5 bg-charcoal md:w-[2px] h-[1px] w-[50px] md:h-[50px]`}></div>
                  <h2 className='flip-text uppercase text-[18px] font-[550] text-charcoal tracking-[2px]'>PORTFOLIO</h2>
                </div>
                <div className='text-[14px] leading-loose font-[450] grid gap-10'>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <Link to='https://stitch.enyata.com/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px] uppercase'>Stitchouse</Link>
                    <br />
                    Tech Stack: <b>React, TypeScript, Rest API</b>
                    <br />
                    Description:
                    Stitchhouse is a fashion marketplace connecting buyers and sellers in a seamless online environment. Developed with React for responsive design and TypeScript for maintainability, Stitchhouse allows for:
                    <br />
                    - Curated product listings
                    <br />
                    - Secure payment processing
                    <br />
                    - Order tracking
                    <br />
                    <br />

                    This platform provides a space for small businesses and independent designers to showcase their collections while offering a smooth shopping experience for customers.
                    <br />
                  </AnimatedSection>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <Link to='https://davetsolutions.com/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px] uppercase'>Dave-T Solutions</Link>
                    <br />
                    Tech Stack: <b>Next.js, Tailwind CSS, Prisma, Neon</b>
                    <br />
                    Description:
                    Dave-T Solutions is a hybrid social enterprise building on a 1988 construction legacy to deliver climate-tech and resilient infrastructure. The platform focuses on sustainable, data-driven technology solutions to support climate adaptation and community strength across Sierra Leone.
                    <br />
                    <br />
                    <b>Key focus areas:</b>
                    <br />
                    - <b>Climate-Tech & IoT:</b> Development of flood monitoring prototypes and real-time environmental data platforms.
                    <br />
                    - <b>Hybrid Enterprise Model:</b> Leveraging commercial engineering and digital services to fund inclusive technology innovation.
                    <br />
                    - <b>Core Capabilities:</b> Civil works, bespoke digital solutions, and operations & maintenance for critical infrastructure.
                    <br />
                  </AnimatedSection>

                  <AnimatedSection disableAnimation={disableAnimation}>
                    <Link to='https://wafeo-official.org/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px] uppercase'>WAFEO Official</Link>
                    <br />
                    Tech Stack: <b>React, TypeScript, Prisma, Neon</b>
                    <br />
                    Description:
                    The official website for the West African Federation of Engineering Organisations (WAFEO). Established in 2011, this regional umbrella body unites professional engineering institutions across West Africa to promote excellence, ethical standards, and regional integration.
                    <br />
                    <br />
                    <b>Key sections include:</b>
                    <br />
                    - <b>Harmonizing Standards:</b> Developing uniform benchmarks for engineering education, training, and professional practice across the sub-region.
                    <br />
                    - <b>Regional Collaboration:</b> A platform for knowledge sharing and advocacy to elevate the role of engineering in national development.
                    <br />
                    - <b>History & Milestones:</b> Documenting leadership transitions and key events, including the first Sierra Leonean and Liberian presidencies.
                    <br />
                  </AnimatedSection>

                  <AnimatedSection disableAnimation={disableAnimation}>
                    <Link to='https://www.trudymorgan.com/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px] uppercase'>Trudy Morgan</Link>
                    <br />
                    Tech Stack: <b>Next.js, Tailwind CSS, React, Prisma, Neon</b>
                    <br />
                    Description:
                    The personal portfolio and professional hub for Ing. Gertrude "Trudy" Morgan, a distinguished Chartered Civil Engineer and global engineering leader. The site chronicles her journey from international consultancy to serving as the first female President of the Sierra Leone Institution of Engineers (SLIE).
                    <br />
                    <br />
                    <b>Key highlights include:</b>
                    <br />
                    - <b>Engineering Leadership:</b> Showcasing her role as President of the Commonwealth Engineers Council and her history as the first African female Fellow of the ICE.
                    <br />
                    - <b>Gender & Youth Empowerment:</b> Highlighting her work as co-founder of Sierra Leone Women Engineers (SLWE) and advocate for women in STEM.
                    <br />
                    - <b>"Trudy Turns Sixty":</b> A celebratory section dedicated to her 60th milestone, reflecting on a career grounded in faith, discipline, and excellence.
                    <br />
                  </AnimatedSection>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <Link to='https://hrms.enyata.com/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px]'>HRMS</Link>
                    <br />
                    Tech Stack: <b>React, GraphQL</b>
                    <br />
                    Description:
                    HRMS is a comprehensive Human Resource Management System designed to streamline HR processes. Built with React for a dynamic and responsive user interface and powered by GraphQL for efficient data querying, HRMS offers a range of features to enhance organizational efficiency.
                    <br />
                    <br />
                    <b>Key features include:</b>
                    <br />
                    - <b>Goal Management:</b> Employees can set and track personal and team goals.
                    <br />
                    - <b>Job Management:</b> A centralized platform for managing job openings, applications, and employee assignments.
                    <br />
                    - <b>Attendance Tracking:</b> Automated systems for logging and managing employee attendance.
                    <br />
                    - <b>Birthday & Event Reminders:</b> Notifications and calendars for employee birthdays and company events.
                    <br />
                    <b>Performance Reviews:</b> Tools for conducting performance evaluations, tracking progress, and providing feedback.
                    <br />
                  </AnimatedSection>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <Link to='https://www.kreditafrica.com/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px] uppercase'>KreditAfrica</Link>
                    <br />
                    Tech Stack: <b>Next.js, TypeScript, PostgreSQL</b>
                    <br />
                    KreditAfrica is a fintech platform that facilitates the management of loans and credits. Built with Next.js for server-side rendering, Typescript for type safety, and PostgreSQL for robust database management.
                    <br />
                    <br />
                    <b>Key features include:</b>
                    <br />
                    - Loan application and management
                    <br />
                    - Credit score tracking
                    <br />
                    - Repayment management
                    <br />
                    <br />
                    The platform aims to provide accessible credit solutions to underserved populations and improve financial inclusion.
                    <br />
                  </AnimatedSection>
                  <AnimatedSection disableAnimation={disableAnimation}>
                    <Link to='https://merifot.enyata.com/' className='font-[600] transition-all duration-300 text-charcoal hover:text-[#ff6347] hover:translate-x-1 inline-block text-[16px] uppercase'>FluxTribe</Link>
                    <br />
                    Tech Stack: <b>React, GraphQL</b>
                    <br />
                    FluxTribe is a social platform designed to foster collaboration on personal and group goals. Using React for a seamless user experience and GraphQL for efficient data interactions, the platform allows users to:

                    <br />
                    - Set and track personal and group goals
                    <br />
                    - Collaborate on shared objectives
                    <br />
                    - Share progress and provide support
                    <br />
                    <br />
                    FluxTribe encourages community-driven achievement by promoting collective growth.
                    <br />

                  </AnimatedSection>


                </div>
              </div>
            </section>

                    <section aria-label="Hard Skills">
                    <div className='grid md:grid-cols-[min-content_1fr] md:gap-10'>
                        <div className='grid h-fit md:justify-items-center'>
                            <div className={`m-5 bg-charcoal md:w-[2px] h-[1px] w-[50px] md:h-[50px]`}></div>
                            <h2 className='flip-text uppercase text-[18px] font-[550] text-charcoal tracking-[2px]'>HARD SKILLS</h2>
                        </div>
                          <div className='text-[14px] h-fit leading-loose font-[450] grid gap-5'>
                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Front-End Development</span>
                                <br/>
                                - Skills: HTML/CSS, JavaScript, TypeScript, React, Next.js
                                <br/>
                                - Tools: GitHub, npm, Yarn, Vite, Webpack, Babel, Tailwind CSS
                                <br />
                                <br />           
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Database Management</span>
                                <br/>
                                - Tools: Firebase, PostgreSQL, Neon
                                <br/>
                                - Skills: Relational Database Design, Real-time Data Integration, and Cloud Data Management.
                                <br />           
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>API Integration</span>
                                <br/>
                                - Tools: GraphQL, REST APIs  
                                <br/>
                                - Skills: Efficient data querying and manipulation
                                <br />
                                <br />           
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Performance Optimization</span>
                                <br/>
                                - Tools: Various optimization techniques and best practices  
                                <br/>
                                - Skills: Speed improvement, performance enhancement, and scalability
                                <br />           
                                <br />
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Testing</span>
                                <br/>
                                - Tools: Jest, Vitest
                                <br />
                                - Skills: Writing reliable and comprehensive tests to ensure code quality
                                <br />           
                                <br />
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Responsive Design</span>
                                <br />
                                - Skills: Creating seamless cross-platform layouts for web and mobile
                                <br/>
                                - Tools: Media Queries, Flexbox, CSS Grid
                                <br />           
                                <br />
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Collaboration & Communication</span>
                                <br />
                                - Tools: Slack, Microsoft Teams, Zoom, Google Meet  
                                <br />
                                - Skills: Effective communication, team collaboration, and cross-functional coordination
                                <br />           
                                <br />
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Data Analysis & Reporting Tools</span>
                                <br />
                                - Tools: Excel, Google Sheets  
                                <br />
                                - Skills: Pivot tables, advanced functions, data visualization
                                <br />
                                - Entry-level: Tableau, Power BI (creating reports and dashboards for data insights)
                                <br />           
                                <br />
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Project Management</span>
                                <br />
                                - Tools: Notion, Click Up, Trello, Asana  
                                <br />
                                - Skills: Task tracking, project planning, and team collaboration
                                <br />           
                                <br />
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Documentation</span>
                                <br />
                                - Tools: Google Docs, Microsoft Office Suite  
                                <br />
                                - Entry-level: Confluence for collaborative documentation
                                <br />           
                                <br />
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>

                            <AnimatedSection disableAnimation={disableAnimation}>
                                <span className='uppercase font-[600] text-charcoal text-[16px]'>Additional Skills</span>
                                <br />
                                - Cross-Browser Compatibility: Ensuring consistent functionality across browsers  
                                <br />
                                - Multilingual Data Management: Managing data in English and French
                                <br />           
                                <br/>
                                <div className={`bg-charcoal w-[50px] h-[2px]`}></div>   
                            </AnimatedSection>
                        </div>
                    </div>
            </section>



                </div>
        </div>
    </div>
    </>
  )
}
